import { Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import NipGusComponent from './nipGusComponent';
import BillzTypographySubTitle from 'components/BillzTypographies/BillzTypographySubTitle';

export default function FoldedContractorPanel(props) {
  const id = props.id ?? 'foldedcontractorpanel';

  const value = props.value;
  const onContractorChanged = props.onContractorChanged;
  const onValueChanged = props.onValueChanged;
  const searchEnabled = props.searchEnabled ?? false;
  const searchFieldLabel = props.searchFieldLabel ?? 'NIP / Nazwa / Adres';
  const searchHelpText = props.searchHelpText ?? '';
  const onValidationChanged = props.onValidationChanged;

  return (
    <MDBox style={{ width: '100%' }}>
      <Stack spacing={1}>
        <BillzTypographySubTitle color="text" variant="body1" sx={{ mb: 1 }}>
          {props.title}
        </BillzTypographySubTitle>
        <NipGusComponent
          id={id}
          width={400}
          error={props.error}
          onContractorDataSet={onContractorChanged}
          onValueChanged={onValueChanged}
          searchEnabled={searchEnabled}
          searchFieldLabel={searchFieldLabel}
          searchHelpText={searchHelpText}
          value={value}
          onValidationChanged={onValidationChanged}
        />
      </Stack>
    </MDBox>
  );
}
